import * as R from 'ramda';

import { DIS } from '@typings/dis';

export const isRotaractClub = (clubType?: string | null): boolean =>
  R.equals(clubType, DIS.ClubTypeEnum.RotaractClub);
